import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Hoe snel kun je spiermassa verliezen</title>
                <link rel="canonical" href={route("blogs.ninth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Het kan weleens voorkomen dat je een tijdje niet kunt trainen. Dit kan zijn door vakantie, blessures of de huidige lockdowns voor de sportscholen. Hoe graag je het ook wilt, er komen periodes dat je niet of minder kunt trainen dan je zou willen."
                />
                <meta
                    property="og:description"
                    content="Het kan weleens voorkomen dat je een tijdje niet kunt trainen. Dit kan zijn door vakantie, blessures of de huidige lockdowns voor de sportscholen. Hoe graag je het ook wilt, er komen periodes dat je niet of minder kunt trainen dan je zou willen."
                />
                <meta property="og:url" content={route("blogs.ninth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Hoe snel kun je spiermassa verliezen - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/snelheid-verlies-spiermassa.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/snelheid-verlies-spiermassa.webp"
                                    type="image/webp"
                                    alt="Snelheid verlies spiermassa"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/snelheid-verlies-spiermassa.jpg"
                                    type="image/jpeg"
                                    alt="Snelheid verlies spiermassa"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/snelheid-verlies-spiermassa.jpg"
                                    alt="Snelheid verlies spiermassa"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Hoe snel kun je je spiermassa verliezen?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Het kan weleens voorkomen dat je een tijdje niet kunt
                        trainen. Dit kan zijn door vakantie, blessures of de
                        huidige lockdowns voor de sportscholen. Hoe graag je het
                        ook wilt, er komen periodes dat je niet of minder kunt
                        trainen dan je zou willen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Dit betekent dat je spieren minder gestimuleerd zullen
                        worden dan ze gewend zijn. Betekent dit dan ook dat je
                        je spiermassa zult gaan verliezen? Dat hangt van
                        verschillende factoren af.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe snel kun je spiermassa verliezen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het is zo dat je je spiermassa niet na een dag niet
                        trainen verliest. Je hoeft niet bang te zijn als je op
                        vakantie gaat dat je een deel van je spieren waar je
                        hard voor hebt getraind zult kwijtraken. Uit onderzoek
                        blijkt namelijk dat je pas spiermassa begint te
                        verliezen na de eerste 2 weken dat je niet getraind.
                        Hierin is ook uitgegaan dat je helemaal niet traint, dus
                        als je minder traint zal deze periode nog langer zijn
                        voordat je spiermassa verliest.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        In het geval dat je langere tijd niet kunt trainen door
                        bijvoorbeeld een blessure of een lockdown, dan zul je de
                        eerste paar weken na de 2 weken nog niet veel spiermassa
                        verliezen. Pas na zo’n 5 á 6 weken zul je merken dat je
                        steeds meer spiermassa gaat verliezen. Daarom is het
                        belangrijk om te blijven trainen als je daartoe een
                        mogelijkheid hebt. Het is nog altijd beter om weinig te
                        trainen dan helemaal niet in dit geval.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat kun je doen om zo min mogelijk spiermassa te
                        verliezen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn wel manieren om ervoor te zorgen dat je zo min
                        mogelijk spiermassa verliest.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Spieren worden opgebouwd uit eiwitten. Op het moment dat
                        je minder tot niet kunt trainen is het dus van belang
                        dat je zorgt dat je nog steeds voldoende eiwitten
                        binnenkrijgt. Dit zorgt ervoor dat je zo min mogelijk
                        spiermassa zult gaan verliezen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Daarnaast is het belangrijk om niet te weinig te eten.
                        Als je in een tekort zit zal je lichaam andere bronnen
                        voor energie gaan aanspreken. Op het moment dat je aan
                        intensieve krachttraining doet krijgt je lichaam een
                        seintje dat je spieren noodzakelijk zijn om zoveel
                        mogelijk te behouden. Hierdoor gebruikt je lichaam
                        voornamelijk vet als energiebron.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        In de periodes dat je minder gaat trainen krijgt je
                        lichaam een minder sterk signaal om de spieren te
                        behouden. Dit betekent dat je lichaam je spiermassa als
                        minder noodzakelijk ziet en zal je lichaam je spieren
                        dus ook mede als energiebron gaan gebruiken. Op deze
                        manier worden je spieren dus afgebroken.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Op het moment dat je minder tot niet kunt trainen is het
                        dus van belang om genoeg eiwitten binnen te krijgen, en
                        niet in een calorietekort te zitten. Hiermee behoud je
                        maximaal je spiermassa. Zorg er daarnaast voor om waar
                        mogelijk toch nog een enkele keer of een ander gedeelte
                        van je lichaam te trainen, zodat je lichaam een prikkel
                        blijft krijgen om de spiermassa te behouden.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
